export const COMBUSTION_ANOM_CODES = {
  71: true,
  72: true,
  81: true,
  84: true,
  86: true,
}
